import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import NewsCard from "../../components/Card/NewsCard";

const NewsBlog = () => {
  return (
    <main className="news_detail_page">
      <div className="cs_container">
        <div className="cs_row news_detail_row">
          <div className="news_detail_sec">
            <Fade top duration={1000}>
              <h5>29 DECEMBER 2018</h5>
            </Fade>
            <Fade bottom duration={1000} delay={100}>
              <h2>
                Impact Solar is ready to sell electricity to SB Design Square
                Ratchapruek branch
              </h2>
            </Fade>
            <Zoom bottom duration={1500} delay={150}>
              <div className="news_detail_img d_flex justify_content_center align_items_center">
                <img
                  src="https://cdn.pixabay.com/photo/2016/11/03/03/56/agriculture-1793403__480.jpg"
                  alt=""
                />
              </div>
            </Zoom>
            <Fade bottom duration={1000} delay={200}>
              <p>
                Impact Solar has invested and installed a solar rooftop at SB
                Design Square Ratchapruek branch facility with a total capacity
                of 408 kW in Bang Kruay, Nonthaburi province, which now is
                already commenced a commercial operation and start selling the
                electricity through our initiative "Private PPA" program on 29th
                December 2018. The system can generate 607,600 units of
                electricity per annual while reduce 344 metric tons per year of
                carbon dioxide.
              </p>
            </Fade>
          </div>
          <div className="news_detail_related_sec">
            <Fade top duration={1000} delay={120}>
              <h2>Related News</h2>
            </Fade>
            <div className="news_card_row">
              {[...new Array(0)].map((v, i) => (
                <div key={i} className="news_col">
                  <NewsCard
                    url="/news-blog"
                    data={{
                      img: "https://cdn.pixabay.com/photo/2018/04/05/23/59/nature-3294632_1280.jpg",
                      title: "21 Feburary 2019",
                      desc: "Impact Solar is ready to sell electricity to Haad Thip PCL",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NewsBlog;
